module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAABPklEQVRIS82XzwrCMAzGv1x9KMGj6AsJ4kEFX0jxKPhQXiMdjXTd1iapOHcabM2vX/41JSQPMxOAI4ALEb3Sb953Zl4A2AE4EBGLnQDqngi9AVgDeADYtsIj9ApgBeAOYCPwDpxBZS9N8AwqNj9wmoA2wSegfTgznwDsCzE0Ka9ABXMOikPwJQ5TfBXcZCvGuBlughK90qx2w63QIPYD9ir3QAdgKzwmhCs/eoqTZqJx+zP+v/RUxCjYoLzUSYuVMAluhFfLrwh2wqvQ0eQa813M3NBnS/EMS0Pc15rDpao4Uf1bsLJOU0e1u9oBVZ9q/1VOSqXfbSBKaBfHr7VMC1RKxrOmV8deA4Ym08t2GfY0h0KxTKwbn2/0mXPYC+6WQT5v1aoulC9SjbezDfTJ1JEqdymtKB9eYTL4Ty5tb06/GzhIH6OLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/Icon1.png
// module id = E32K
// module chunks = 1